module.exports = __webpack_public_path__ + "static/img/sys-1.c614c65.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sys-1.png
// module id = JW5l
// module chunks = 1